export const TYPES = ['Grade/Years', 'Ages'];


// WEBPACK FOOTER //
// ./src/constants/ages-grades.js